import qs from "qs";
import { pick, each } from "lodash";
import getConfig from "../../config";
function getTracker() {
    return window.mixpanel;
}
/**
 * Reads query string from browser and registers any 'utm_*' strings to mixpanel for tracking.
 */
function setUTMParams(queryString) {
    if (queryString && queryString.includes("utm_")) {
        var utmTags = ["utm_term", "utm_campaign", "utm_medium", "utm_source", "utm_content", "utm_type", "utm_market", "utm_product"];
        utmTags.forEach(function (element) {
            getTracker().unregister(element + " [last_touch]");
        });
        var params_1 = {};
        each(pick(qs.parse(queryString.replace("?", "")), utmTags), function (value, key) {
            params_1[key + " [last_touch]"] = value;
        });
        getTracker().register(params_1);
    }
}
function trackEvent(name, attributes) {
    var mixpanel = getTracker();
    if (mixpanel) {
        mixpanel.track(name, attributes);
    }
}
function handleLogin(attributes) {
    var mixpanel = getTracker();
    if (mixpanel) {
        mixpanel.identify(attributes.user_id);
        mixpanel.people.set(attributes);
        mixpanel.people.unset("$initial_referrer");
        mixpanel.track("login_user", attributes);
    }
}
function handleLogout() {
    var mixpanel = getTracker();
    mixpanel.reset();
}
var platformFunctions = {
    setUTMParams: setUTMParams,
    trackEvent: trackEvent,
    handleLogin: handleLogin,
    handleLogout: handleLogout,
    setup: setup
};
export default platformFunctions;
/* eslint-disable */
function setup(env) {
    if (getTracker()) {
        // already loaded
        return;
    }
    var config = getConfig(env);
    if (config.mixpanel) {
        ;
        (function (e, a) {
            if (!a.__SV) {
                var b = window;
                try {
                    var c;
                    var l_1;
                    var i = void 0;
                    var j = b.location;
                    var g = j.hash;
                    c = function (a, b) {
                        return (l_1 = a.match(RegExp(b + "=([^&]*)"))) ? l_1[1] : null;
                    };
                    g &&
                        c(g, "state") &&
                        ((i = JSON.parse(decodeURIComponent(c(g, "state")))),
                            i.action === "mpeditor" &&
                                (b.sessionStorage.setItem("_mpcehash", g), history.replaceState(i.desiredHash || "", e.title, j.pathname + j.search)));
                }
                catch (m) { }
                var k_1;
                var h_1;
                window.mixpanel = a;
                a._i = [];
                a.init = function (b, c, f) {
                    function e(b, a) {
                        var c = a.split(".");
                        c.length == 2 && ((b = b[c[0]]), (a = c[1]));
                        b[a] = function () {
                            b.push([a].concat(Array.prototype.slice.call(arguments, 0)));
                        };
                    }
                    var d = a;
                    typeof f !== "undefined" ? (d = a[f] = []) : (f = "mixpanel");
                    d.people = d.people || [];
                    d.toString = function (b) {
                        var a = "mixpanel";
                        f !== "mixpanel" && (a += "." + f);
                        b || (a += " (stub)");
                        return a;
                    };
                    d.people.toString = function () {
                        return d.toString(1) + ".people (stub)";
                    };
                    k_1 = "disable time_event track track_pageview track_links track_forms register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user".split(" ");
                    for (h_1 = 0; h_1 < k_1.length; h_1++)
                        e(d, k_1[h_1]);
                    a._i.push([b, c, f]);
                };
                a.__SV = 1.2;
                b = e.createElement("script");
                b.type = "text/javascript";
                b.async = !0;
                b.src =
                    typeof MIXPANEL_CUSTOM_LIB_URL !== "undefined"
                        ? MIXPANEL_CUSTOM_LIB_URL
                        : e.location.protocol === "file:" && "//cdn4.mxpnl.com/libs/mixpanel-2-latest.min.js".match(/^\/\//)
                            ? "https://cdn4.mxpnl.com/libs/mixpanel-2-latest.min.js"
                            : "//cdn4.mxpnl.com/libs/mixpanel-2-latest.min.js";
                c = e.getElementsByTagName("script")[0];
                c.parentNode.insertBefore(b, c);
            }
        })(document, window.mixpanel || []);
        window.mixpanel.init(config.mixpanel, {
            property_blacklist: ["$referrer", "$initial_referrer"]
        });
        setUTMParams(window.location.search);
    }
}
